export default __webpack_public_path__ + "static/media/cross-white.e51428f1.svg";